@if (indicators(); as metrics) {
  <div class="flex gap-4">
    <selectable-widget
      #sw1
      [exportMode]="exportMode()"
      [selected]="isWidgetSelected(sw1.nativeEl)"
      (widgetToggle)="widgetToggle.emit({ checked: $event, el: sw1.nativeEl })"
      class="card-grey flex h-36 grow flex-col gap-2 p-4">
      <div>
        <small class="font-normal text-surface-500">
          {{ 'Portfolio Balance' | uppercase }}
        </small>
        <h1 class="mb-2 font-body font-bold">
          <currency-amount
            [value]="metrics.portfolio_balance.total"
            [currency]="currency()" />
        </h1>
        <small class="text-surface-500">
          Eligible
          <span class="font-bold">
            <currency-amount
              [value]="metrics.portfolio_balance.elegible"
              [currency]="currency()"
              [showCode]="false" />
          </span>
        </small>
        <small class="text-surface-500">
          Ineligible
          <span class="font-bold">
            <currency-amount
              [value]="metrics.portfolio_balance.inelegible"
              [currency]="currency()"
              [showCode]="false" />
          </span>
        </small>
      </div>
    </selectable-widget>

    <selectable-widget
      #sw2
      [exportMode]="exportMode()"
      [selected]="isWidgetSelected(sw2.nativeEl)"
      (widgetToggle)="widgetToggle.emit({ checked: $event, el: sw2.nativeEl })"
      class="card-grey flex h-36 grow flex-col gap-2 p-4">
      <div>
        <small class="font-normal text-surface-500">
          {{ 'Outstanding Debt' | uppercase }}
        </small>
        <h1 class="mb-2 font-body font-bold">
          <currency-amount
            [value]="metrics.outstanding_debt"
            [currency]="currency()" />
        </h1>
        <small class="text-surface-500">Unpaid capital</small>
      </div>
    </selectable-widget>

    <selectable-widget
      #sw3
      [exportMode]="exportMode()"
      [selected]="isWidgetSelected(sw3.nativeEl)"
      (widgetToggle)="widgetToggle.emit({ checked: $event, el: sw3.nativeEl })"
      class="card-grey flex h-36 grow flex-col gap-2 p-4">
      <div>
        <small class="font-normal text-surface-500">
          {{ 'Maximum credit amount' | uppercase }}
        </small>
        <h1 class="mb-2 font-body font-bold">
          <currency-amount
            [value]="metrics.total_credit_amount"
            [currency]="currency()" />
        </h1>
        <small class="text-surface-500">Total capital disbursed</small>
      </div>
    </selectable-widget>

    @if (metrics.interest_rate) {
      <selectable-widget
        #sw4
        [exportMode]="exportMode()"
        [selected]="isWidgetSelected(sw4.nativeEl)"
        (widgetToggle)="
          widgetToggle.emit({ checked: $event, el: sw4.nativeEl })
        "
        class="card-grey flex h-36 grow flex-col gap-2 p-4">
        <div>
          <small class="font-normal text-surface-500">
            {{ 'Average interest rate' | uppercase }}
          </small>
          <h1 class="mb-2 font-body font-bold">
            {{ metrics.interest_rate * 100 | number: '1.2-2' }} %
          </h1>
          <small class="text-surface-500 underline"
            >Weighted average rate</small
          >
          @if (metrics.spread) {
            <small class="text-surface-500">
              Spread: <span class="font-bold">{{ metrics.spread }}% </span>
            </small>
          }
        </div>
      </selectable-widget>
    }
  </div>
}
